var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{staticClass:"remocao",attrs:{"menu-name":"PRO","no-title":"","menu":_vm.menu,"menu-active":_vm.active,"hfull":""}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }